export default {
      id: "next-usage",
      viewBox: "0 0 22.78 41.31",
      url: __webpack_public_path__ + "img/icons.507a1d9d.svg#next",
      toString: function () {
        return this.url;
      }
    }